import React from 'react';
import { Map, Marker, Popup, TileLayer, GeoJSON } from 'react-leaflet';
import { mapUrl, getIconMarker } from '../../../utils/map';
import './activity-list.scss';
import defaultThumbnail from '../../../assets/thumbnail-default.jpg';
import { Card } from 'antd';
import { thumbs } from '../../../utils/static-data';
import { guarico } from '../../../utils/guarico';

class ActivityMap extends React.Component {

  state = {
    activities: null
  }

  render() {
    return (
      this.renderMap()
    );
  }

  renderMap = () => {
    const position = [9.00, -66.00]
    const map = (
      <Map center={position} zoom={8}>
        <TileLayer
          url={mapUrl}
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />
        <GeoJSON key="guarico-limits" data={guarico} />
        {this.setMarkers()}
      </Map>
    )
    return map;
  }

  setMarkers = () => {

    const latNLng = [];

    return this.state.activities.map((a, i) => {
      const pos = [a.lat, a.lng];
      latNLng.push(JSON.stringify(pos));
      
      if (latNLng.includes(JSON.stringify(pos))) {
        pos[0] = Number.parseFloat(pos[0]) + (Math.random() * 0.00009);
        pos[1] = Number.parseFloat(pos[1]) + (Math.random() * 0.00009);
      }

      return (
        <Marker key={i} icon={getIconMarker(a.status)} position={pos}>
          <Popup>
            <Card bordered={false} cover={
              <img
                alt="thumbnail"
                src={a.thumbnail ? (thumbs + a.thumbnail) : defaultThumbnail}
              />
            }>
              <Card.Meta
                title={a.title}
                description={`${a.description} \n ${a.dayOfWeek} - ${a.date} ${new Date(Number.parseInt(a.rawDate) * 1000).toLocaleTimeString()}`}
              />
            </Card>
          </Popup>
        </Marker>
      );
    });
  }

  static getDerivedStateFromProps(nextProps) {
    return ({ activities: nextProps.activities });
  }
}

export default ActivityMap;